import  gql  from 'graphql-tag'

export const CREDIT_ANALYST = gql`mutation creditAnalyst($input: CreditAnalystMutationInput!){
    creditAnalyst(input: $input){
        errors{
            field
            messages
        }
        creditAnalyst{
            id
            user{
                id
                name
                surname
                username
                email
                authSystem
                isActive
                group{
                    id
                    name
                }
                creditanalyst{
                    id
                    office{
                        id
                        name
                        regional{
                            id
                            name
                        }
                    }
                    analystType{
                        id
                        name
                    }
                }
            }    
        }
    }
}`;